import { Directive, ElementRef, HostListener, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Директива для вырезания из инпута определенных символов
 * Например, при вводе номера телефона нам пробелы не нужны совсем
 * <input appCut [cutSymbols]="[' ']">
 */
@Directive({
  selector: 'input[appCut]',
})
export class CutDirective {
  @Input() cutSymbols: string | Array<string> = '';

  @HostListener('input', ['$event.target', '$event.target.value'])
  onInput(el: any, value: string): void {
    if (this.cutSymbols === null || this.cutSymbols.length === 0) {
      return;
    }

    if (typeof this.cutSymbols === 'string') {
      this.cutSymbols = [this.cutSymbols];
    }

    const formattedValue = this.format(value);

    if (String(formattedValue) !== String(value)) {
      const selectionStart = <number>(el as HTMLInputElement).selectionStart;
      const selectionEnd = <number>(el as HTMLInputElement).selectionEnd;
      const offset = el.value.length - formattedValue.length;
      el.value = formattedValue;
      (el as HTMLInputElement).selectionStart = selectionStart - offset;
      (el as HTMLInputElement).selectionEnd = selectionEnd - offset;

      this.dispatchEvent(el, 'input');
    }
  }

  constructor(private elementRef: ElementRef, @Inject(DOCUMENT) private document: any) {}

  private format(value: string): string {
    for (const symbol of this.cutSymbols) {
      value = value.replace(symbol, '');
    }
    return value;
  }

  private dispatchEvent(el: HTMLInputElement, eventType: string): void {
    const event = this.document.createEvent('Event');
    event.initEvent(eventType, false, false);
    el.dispatchEvent(event);
  }
}
